var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowsSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    width: 42,
    height: 31,
    rx: 15.5,
    transform: "rotate(90 31.5 0)",
    fill: "#018DF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7943 22.1428L12.7943 12.4384L15.8608 15.5049C16.1445 15.779 16.5967 15.7711 16.8708 15.4873C17.1381 15.2105 17.1381 14.7717 16.8708 14.4949L12.585 10.2091C12.3061 9.93029 11.854 9.93029 11.575 10.2091L7.28921 14.4949C7.01512 14.7786 7.02296 15.2308 7.30676 15.5049C7.58359 15.7723 8.02241 15.7723 8.29925 15.5049L11.3657 12.4385L11.3657 22.1428C11.3657 22.5373 11.6855 22.8572 12.08 22.8572C12.4745 22.8572 12.7943 22.5373 12.7943 22.1428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2995 27.3623C24.5735 27.0785 24.5657 26.6263 24.2819 26.3522C24.0051 26.0849 23.5663 26.0849 23.2894 26.3522L20.2229 29.4187L20.2229 19.7143C20.2229 19.3198 19.9031 19 19.5086 19C19.1141 19 18.7943 19.3198 18.7943 19.7143L18.7943 29.4187L15.7278 26.3522C15.4538 26.0685 15.0016 26.0607 14.7178 26.3347C14.434 26.6087 14.4262 27.0609 14.7003 27.3447C14.706 27.3507 14.7118 27.3565 14.7178 27.3623L19.0036 31.6481C19.2825 31.9269 19.7346 31.9269 20.0136 31.6481L24.2995 27.3623Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsSwap);
export default __webpack_public_path__ + "static/media/icon-arrows-swap.24191b20.svg";
export { ForwardRef as ReactComponent };